import React, { FC, useState } from 'react';
import { Box, Button, Divider, Typography, useTheme } from '@mui/material';
import { ExpandLess, MoreVert } from '@mui/icons-material';
import { IReviewNew, IReviewNewProps } from '../../../shared/interfaces/IReviewNew';
import ReviewWrapper from '../ReviewWrapper';
import ReviewHeader from '../ReviewHeader';
import ReviewContent from '../ReviewContent';
import ReviewFooter from '../ReviewFooter';
import { useTranslation } from 'react-i18next';
import Block from '../../Block/Block';
import { CommunityManagement } from '../../../shared/interfaces/ICommunityManagement';

interface Props extends IReviewNewProps {}

const KununuReview: FC<Props> = ({
  communityManagement,
  commentingModule,
  hideHeader,
  hideFooter,
  statusModule,
  status,
  deletionModule,
  reviewEntry,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [showAllBlocks, setShowAllBlocks] = useState(false);
  const { header, position, positionText, rating, companyComment, reviewLink, blocks, text } =
    reviewEntry.review;

  const renderedBlocks = () => {
    const validBlocks =
      blocks &&
      blocks.filter((value) => typeof value.rating === 'number') &&
      blocks.filter((value) => value.title !== '');

    if (validBlocks && validBlocks.length > 0) {
      const firstBlock = validBlocks[0];
      return (
        <Box sx={{ mt: theme.spacing(1) }}>
          {!showAllBlocks ? (
            <Box>
              <Divider orientation="horizontal" />
              <Block
                rating={firstBlock.rating || 0}
                text={firstBlock.text || ''}
                title={firstBlock.title || ''}
              />
              <Button
                variant="outlined"
                size="small"
                startIcon={<MoreVert />}
                onClick={() => setShowAllBlocks(!showAllBlocks)}
                sx={{ my: theme.spacing(1) }}
              >
                {t('show_more')}
              </Button>
            </Box>
          ) : (
            <Box>
              {validBlocks.map(({ rating, text, title }, index) => (
                <Box
                  key={`Review_${reviewEntry.id}_Block_${index}`}
                  sx={{ mt: theme.spacing(1) }}
                >
                  <Divider orientation="horizontal" />
                  <Block
                    rating={rating || 0}
                    text={text || ''}
                    title={title || ''}
                  />
                </Box>
              ))}
              <Button
                variant="outlined"
                size="small"
                startIcon={<ExpandLess />}
                onClick={() => setShowAllBlocks(!showAllBlocks)}
                sx={{ mb: theme.spacing(1) }}
              >
                {t('show_less')}
              </Button>
            </Box>
          )}
        </Box>
      );
    }
    return null;
  };

  return (
    <ReviewWrapper
      communityManagement={communityManagement}
      commentingModule={commentingModule}
      hideHeader={hideHeader}
      hideFooter={hideFooter}
      rating={rating}
      reviewLink={reviewLink}
      statusModule={statusModule}
      status={status}
      deletionModule={deletionModule}
      dateFormat={{ comment: 'MMM yyyy' }}
      reviewEntry={reviewEntry}
    >
      {(position || positionText) && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {position && (
            <Typography
              variant="caption"
              sx={{
                color: theme.palette.text.secondary,
              }}
            >
              {position}
            </Typography>
          )}
          {positionText && (
            <Typography
              variant="caption"
              sx={{
                color: theme.palette.text.secondary,
                cursor: 'pointer',
              }}
            >
              {positionText}
            </Typography>
          )}
        </Box>
      )}
      {header && (
        <Box>
          <Typography
            variant="h6"
            sx={{
              mt: theme.spacing(2),
            }}
          >
            {header}
          </Typography>
        </Box>
      )}
      {blocks && blocks.length > 0 && <Box>{renderedBlocks()}</Box>}
    </ReviewWrapper>
  );
};

export default KununuReview;
